import {DownloadOutlined, PrinterOutlined} from '@ant-design/icons';
import {Button, Modal} from 'antd';
import html2pdf from 'html2pdf.js';
import PropTypes from 'prop-types';
import {useRef, useState} from 'react';
import toast from 'react-hot-toast';
// eslint-disable-next-line import/no-unresolved
import {useReactToPrint} from 'react-to-print';

import logo from '../../../../../Assets/Logo3.png';

const PRINT_STYLE = `
  @page {
    size: A4 portrait;
    margin: 0;
  }

  @media print {
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      width: 210mm !important;
      background: #fff !important;
    }

    body * {
      visibility: hidden !important;
    }

    .invoice-print-area,
    .invoice-print-area * {
      visibility: visible !important;
    }

    .invoice-print-area {
      position: absolute !important;
      left: 0 !important;
      top: 0 !important;
      width: 210mm !important;
      min-height: 297mm !important;
      margin: 0 !important;
      padding: 5mm !important;
      background: #fff !important;
      box-sizing: border-box !important;
    }

    .invoice-print-area table {
      page-break-inside: avoid;
    }

    .invoice-print-area tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    .invoice-print-area img {
      max-width: 100%;
    }

    .ant-modal,
    .ant-modal-wrap,
    .ant-modal-mask,
    .ant-modal-content,
    .ant-modal-header,
    .ant-modal-footer {
      visibility: hidden !important;
    }
  }
`;

const COMPANY = {
  name:    'SAMADHAN INDUSTRIES',
  address: 'Plot No.- F-1, MIDC, ISHWARPUR.',
  city:    'Tal.- Walwa, Dist.- Sangli-415409',
  state:   'State Code: MH (27)',
  email:   'samadhanindustriesgroup89@gmail.com',
  phone:   '8412912712 / 8485824712',
  gstin:   'NA',
  pan:     'ABRPG7669K',
};

const BANK = {
  name:   'BANK OF MAHARASHTRA',
  branch: 'URUN ISLAMPUR',
  ac:     '60293437719',
  ifsc:   'MAHB0000466',
  acType: 'CURRENT A/C',
};

const FC = ({children, justify = 'justify-center', bold = false, className = ''}) => (
  <div
    className={`flex items-center w-full text-[11px] font-['Times_New_Roman',Times,serif] overflow-hidden whitespace-nowrap ${justify} ${bold ? 'font-bold' : ''} ${className}`}
  >
    {children}
  </div>
);

FC.propTypes = {
  children:  PropTypes.node,
  justify:   PropTypes.string,
  bold:      PropTypes.bool,
  className: PropTypes.string,
};

export const InvoiceTemplate = ({invoiceData, printRef}) => {
  const {
    invoiceNo, invoiceDate, ldNo, paidAmount, pendingAmount,
    billing, shipping, terms,
    rows, totals, amountInWords,
  } = invoiceData;

  const grossValue   = totals.total;
  const taxAmount    = (totals.cgst || 0) + (totals.igst || 0);
  const invoiceValue = grossValue;
  const displayRows  = Array.from({length: Math.max(rows.length, 5)});

  return (
    <div
      ref={printRef}
      className={'invoice-print-area font-[\'Times_New_Roman\',Times,serif] text-[11px] text-black bg-white p-[8mm_10mm] w-full box-border'}
    >
      
      <table className={'w-full border-collapse mb-1'}>
        <tbody>
          <tr>
            <td className={'align-middle w-[33%] text-center'}>
              <p className={'text-center text-[9px] m-0 mb-0.5 font-bold'}>
                SUBJECT TO ISHWARPUR JURISDICTION
              </p>
              <img
                src={logo}
                alt={'Samadhan Industries'}
                className={'h-14 object-contain block mx-auto'}
                onError={e => { e.target.style.display = 'none'; }}
              />
            </td>
            <td className={'align-middle w-[34%] text-center'}>
              <p className={'text-[22px] font-bold m-0 tracking-widest font-[\'Times_New_Roman\',Times,serif]'}>
                TAX INVOICE
              </p>
            </td>
            <td className={'align-middle w-[33%] text-right'}>
              <p className={'m-0 mb-0.5 font-bold text-[11px]'}>INVOICE NO: {invoiceNo}</p>
              <p className={'m-0 font-bold text-[11px]'}>INVOICE DATE: {invoiceDate}</p>
            </td>
          </tr>
        </tbody>
      </table>
     
      <p className={'text-center text-[8px] mb-1 mt-0'}>
        ORIGINAL FOR RECIPIENT, DUPLICATE FOR TRANSPORTER, TRIPLICATE FOR SUPPLIER
        (ISSUE OF INVOICE UNDER RULE 7 OF CENTRAL GST RULES IN SECTION - 31 - 2017)
      </p>

      <table className={'w-full border-collapse mb-4'}>
        <tbody>
          <tr>
            <td className={'align-top w-[60%] pr-2'}>
              <p className={'m-0 text-[11px]'}><strong>Company Name :-</strong> <strong>{COMPANY.name}</strong></p>
              <p className={'m-0 text-[11px]'}><strong>Address:-</strong></p>
              <p className={'m-0 text-[11px]'}>{COMPANY.address}</p>
              <p className={'m-0 text-[11px]'}>{COMPANY.city}</p>
              <p className={'m-0 text-[11px]'}>{COMPANY.state}</p>
              <p className={'m-0 text-[11px]'}>Email- {COMPANY.email}</p>
              <p className={'m-0 text-[11px]'}>Factory/off.- {COMPANY.phone}</p>
              <p className={'m-0 text-[11px]'}>
                <strong>GSTIN:</strong> {COMPANY.gstin}&nbsp;&nbsp;&nbsp;
                <strong>PAN NO.-</strong> {COMPANY.pan}
              </p>
            </td>
            <td className={'align-top w-[40%] border border-black p-1'}>
              <table className={'w-full border-collapse'}>
                <tbody>
                  <tr>
                    <td className={'px-1 pb-1 font-bold text-black text-[11px]'}>
                      BANKING DETAILS :
                    </td>
                  </tr>
                  {[
                    ['BANK',     BANK.name],
                    ['BR',       BANK.branch],
                    ['A/C',      BANK.ac],
                    ['IFSC',     BANK.ifsc],
                    ['A/C TYPE', BANK.acType],
                  ].map(([label, val]) => (
                    <tr key={label}>
                      <td className={' font-medium text-[10px]'}>
                        {label} : {val}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
     
      <table className={'w-full border-collapse border  mb-1'}>
        <thead>
          <tr>
            <th className={' border-t border-l px-1.5 pb-2 text-center w-1/2 bg-[#e9edf4] font-bold text-[11px]'}>
              Billing Address
            </th>
            <th className={'border-l border-t border-r px-1.5 pb-2 text-center w-1/2 bg-[#e9edf4] font-bold text-[11px]'}>
              Shipping Address
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={'border-t px-2 py-1.5 align-top text-[11px]'}>
              <p className={'m-0 text-[11px]'}><strong>Customer Name :-</strong> {(billing?.customerName || '').toUpperCase()}</p>
              {billing?.businessName && <p className={'m-0 text-[11px]'}><strong>Business :-</strong> {billing.businessName.toUpperCase()}</p>}
              <p className={'m-0 text-[11px]'}><strong>Address:-</strong> {billing?.address || ''}</p>
              {billing?.district && <p className={'m-0 text-[11px]'}>DIST.- {billing.district.toUpperCase()}</p>}
              <p className={'m-0 text-[11px]'}>
                {billing?.cellNo && <><strong>CELL NO:</strong> {billing.cellNo}</>}
                {billing?.stateCode && <>&nbsp;&nbsp;&nbsp;<strong>Code-</strong> ({billing.stateCode})</>}
              </p>
              <p className={'m-0 text-[11px]'}><strong>GSTIN :-</strong> {billing?.gstin || 'N/A'}</p>
            </td>
            <td className={'border-t border-l px-2 py-1.5 align-top text-[11px]'}>
              <p className={'m-0 text-[11px]'}><strong>Customer Name:</strong> {shipping?.customerName || 'AS SAME'}</p>
              <p className={'m-0 text-[11px]'}><strong>Address:</strong> {shipping?.address || 'AS SAME'}</p>
              {shipping?.street   && <p className={'m-0 text-[11px]'}><strong>Street:</strong> {shipping.street}</p>}
              {shipping?.city     && <p className={'m-0 text-[11px]'}><strong>City:</strong> {shipping.city.toUpperCase()}</p>}
              {shipping?.district && <p className={'m-0 text-[11px]'}><strong>District:</strong> {shipping.district.toUpperCase()}</p>}
              {shipping?.pinCode  && <p className={'m-0 text-[11px]'}><strong>Pin Code:</strong> {shipping.pinCode}</p>}
            </td>
          </tr>
        </tbody>
      </table>
      
      <table style={{width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', marginBottom: '4px', border: '1px solid black'}}>
        <colgroup>
          <col style={{width: '4%', paddingBottom: '2px'}} />
          <col style={{width: '32%'}} />
          <col style={{width: '9%'}} />
          <col style={{width: '6%'}} />
          <col style={{width: '5%'}} />
          <col style={{width: '5%'}} />
          <col style={{width: '7%'}} />
          <col style={{width: '6%'}} />
          <col style={{width: '12%'}} />
          <col style={{width: '14%'}} />
        </colgroup>
        <thead>
          <tr>
            <th
              colSpan={10}
              style={{border: '1px solid black', padding: '6px 4px', textAlign: 'center', verticalAlign: 'middle', fontWeight: 'bold', fontSize: '11px', backgroundColor: '#e9edf4', fontFamily: '\'Times New Roman\', Times, serif'}}
            >
              PRODUCTS SUPPLIED
            </th>
          </tr>
          <tr>
            {[
              {label: 'SR\nNO'},
              {label: 'PRODUCT'},
              {label: 'HSN\nCODE'},
              {label: 'KGS\nBAG'},
              {label: 'BAGS'},
              {label: 'QTY'},
              {label: 'C/\nSGST'},
              {label: 'IGST'},
              {label: 'PRICE/\nUNIT'},
              {label: 'TOTAL'},
            ].map(({label}) => (
              <th
                key={label}
                style={{
                  borderBottom:          '1px solid black',
                  borderLeft:          '1px solid black',
                  padding:         '4px 2px',
                  textAlign:       'center',
                  verticalAlign:   'middle',
                  fontWeight:      'bold',
                  fontSize:        '10px',
                  backgroundColor: '#e9edf4',
                  whiteSpace:      'pre-line',
                  height:          '36px',
                  fontFamily:      '\'Times New Roman\', Times, serif',
                }}
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((_, idx) => {
            const r = rows[idx];

            const td = (content, extraStyle = {}) => (
              <td
                style={{
                  borderBottom:          '1px solid black',
                  borderLeft:          '1px solid black',                 
                  height:         '28px',
                  padding:        '0 4px',
                  verticalAlign:  'middle',
                  textAlign:      'center',
                  overflow:       'hidden',
                  whiteSpace:     'nowrap',
                  fontFamily:     '\'Times New Roman\', Times, serif',
                  fontSize:       '11px',
                  paddingBottom:  '2px',
                  ...extraStyle,
                }}
              >
                {content}
              </td>
            );

            return (
              <tr key={idx} style={{height: '28px'}}>
                {td(idx + 1)}
                {td(r?.productLabel || '', {
                  textAlign:    'left',
                  paddingLeft:  '6px',
                  fontWeight:   r ? 'bold' : 'normal',
                  textOverflow: 'ellipsis',
                })}
                {td(r?.hsnCode || (r ? '#N/A' : ''))}
                {td(r?.kgsBag  !== undefined && r?.kgsBag  !== '' ? r.kgsBag  : (r ? '0' : ''))}
                {td(r?.bags    !== undefined && r?.bags    !== '' ? r.bags    : (r ? '0' : ''))}
                {td(r?.qty     !== undefined && r?.qty     !== '' ? r.qty     : (r ? '0' : ''))}
                {td(r?.cgst    !== undefined && r?.cgst    !== '' ? r.cgst    : (r ? '0' : ''))}
                {td(r?.igst    !== undefined && r?.igst    !== '' ? r.igst    : (r ? '0' : ''))}
                {td(r?.rate    !== undefined && r?.rate    !== ''
                  ? Number(r.rate).toLocaleString('en-IN') : (r ? '0' : ''))}
                {td(r?.total > 0 ? Number(r.total).toLocaleString('en-IN') : (r ? '0' : ''), {
                  fontWeight: r ? 'bold' : 'normal',
                  paddingBottom: '2px',
                })}
              </tr>
            );
          })}
        
          {(() => {
            const totalTd = (content, colSpan) => (
              <td
                colSpan={colSpan}
                style={{
                  border:          '1px solid black',           
                  height:          '28px',
                  padding:         '0 4px',
                  verticalAlign:   'middle',
                  textAlign:       'center',
                  fontWeight:      'bold',
                  fontSize:        '11px',
                  fontFamily:      '\'Times New Roman\', Times, serif',
                  backgroundColor: '#e9edf4',
                }}
              >
                {content}
              </td>
            );
            return (
              <tr style={{height: '28px', backgroundColor: '#e9edf4'}}>
                {totalTd('TOTAL', 4)}
                {totalTd(totals.bags || 0, 1)}
                {totalTd(totals.qty  || 0, 1)}
                {totalTd(totals.cgst || 0, 1)}
                {totalTd(totals.igst || 0, 1)}
                {totalTd('',             1)}
                {totalTd(Number(totals.total).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}), 1)}
              </tr>
            );
          })()}
        </tbody>
      </table>
     
      <div className={'border border-black px-2 py-1 mb-1 justify-center items-center020'}>
        <span className={'font-bold text-[18px]'}> Total Amount in Words: </span>

        <span className={'text-[16px] uppercase font-bold '}>{amountInWords}</span>
      </div>
     
      <table className={'w-full border-collapse mb-1'}>
        <tbody>
          <tr>
            {/* Invoice Terms */}
            <td className={'align-top w-[65%] pr-2'}>
              <table className={'w-full border '}>
                <tbody>
                  <tr>
                    <td colSpan={2} className={'border px-1.5 pb-2 text-center font-bold  bg-[#e9edf4] text-[11px] align-middle'}>
                      Invoice Terms
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-b border-r px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      1. CUSTOMER ORDER NO.- {terms?.customerOrderNo || 'TELEPHONIC'}
                    </td>
                    <td className={'border-b border-r px-1.5 py-1.5 text-center text-[11px] align-middle'}>
                      INVOICE DATE: {invoiceDate}
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-b px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      2. TERMS OF PAYMENT:- {terms?.termsOfPayment || '7 DAYS'}
                    </td>
                    <td className={'border-b px-1.5 py-1.5 text-left text-[11px] align-middle'}>
  LD NO :- {terms?.ldNumber || billing?.ldnumber || '-'}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className={'border-b px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      3. INTEREST : @ 18% P.A. CHARGED IF NOT PAID ON/BEFORE DUE DATE (21 DAYS)
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-b border-r px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      4. DELIVERY NOTE:- {terms?.deliveryNote || invoiceNo}
                    </td>
                    <td className={'border-b px-1.5 py-1.5 text-center text-[11px] align-middle'}>
                      INVOICE DATE: {invoiceDate}
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-b border-r  px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      5. DISPATCHED THROUGH:- {(terms?.dispatchedThrough || 'BY ROAD').toUpperCase()}
                    </td>
                    <td className={'border-b px-1.5 py-1.5 text-center text-[11px] align-middle'}>
                      DESTINATION-: {(terms?.destination || '').toUpperCase()}
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-b border-r  px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      7. MOTOR VEHICLE NO :- {(terms?.motorVehicleNo || '').toUpperCase()}
                    </td>
                    <td className={'border-b px-1.5 py-1.5 text-center text-[11px] align-middle'}>
                      TRANSPORT - LNT
                    </td>
                  </tr>
                  <tr>
                    <td className={'border-r px-1.5 py-1.5 text-left text-[11px] align-middle'}>
                      8. FREIGHT:- {(terms?.freight || 'TO PAY').toUpperCase()}
                    </td>
                    <td className={'px-1.5 py-1.5 text-left text-[11px] align-middle'}>
  PAYMENT MODE :- {(terms?.modeOfPayment || '-').toUpperCase()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            
            <td className={'align-top w-[35%]'}>
              <table className={'w-full border-collapse border border-black'}>
                <tbody>
                  {[
                    {label: 'Gross Value',    value: Number(grossValue).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}),    bg: '',          color: ''},
                    {label: 'Tax (Exempted)', value: taxAmount > 0 ? Number(taxAmount).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00', bg: '', color: ''},
                    {label: 'Invoice Value',  value: Number(invoiceValue).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}),   bg: '',          color: ''},
                    {label: 'Paid Amount',    value: Number(paidAmount || 0).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}), bg: 'bg-[#f0fff0]', color: 'text-[#006600]'},
                    {
                      label: 'Total Payable',
                      value: Number(pendingAmount || 0).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                      bg:    (pendingAmount || 0) > 0 ? 'bg-[#fff0f0]' : 'bg-[#f0fff0]',
                      color: (pendingAmount || 0) > 0 ? 'text-[#cc0000]' : 'text-[#006600]',
                    },
                  ].map(({label, value, bg, color}) => (
                    <tr key={label}>
                      <td className={`border-b px-1.5 pb-2 font-bold text-left text-[11px] align-middle ${bg} ${color}`}>
                        {label}
                      </td>
                      <td className={`border-b border-l px-1.5 pb-2 font-bold text-right text-[11px] align-middle ${bg} ${color}`}>
                        {value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div className={'flex justify-end items-end mt-2'}>
        <div className={'text-right'}>
          <p className={'m-0 font-bold text-[11px]'}>For, {COMPANY.name}</p>
          <p className={'mt-10 mb-0 italic text-[10px]'}>Authorised Signatory</p>
        </div>
      </div>
      
    </div>
  );
};

InvoiceTemplate.propTypes = {
  invoiceData: PropTypes.object.isRequired,
  printRef:    PropTypes.object.isRequired,
};

const GenerateBillPdf = ({open, onClose, invoiceData}) => {
  const printRef                      = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Invoice-${invoiceData?.invoiceNo || 'Bill'}`,
    pageStyle: PRINT_STYLE,
  });

  const handleDownload = async () => {
    if (!printRef.current) {return;}
    setDownloading(true);
    try {
      await html2pdf()
        .set({
          margin:   [5, 5, 5, 5],
          filename: `${invoiceData.invoiceNo.replace(/\//g, '-')}.pdf`,
          image:    {type: 'jpeg', quality: 0.98},
          html2canvas: {
            scale:   2,
            useCORS: true,
            logging: false,
            onclone: doc => {
              
              doc.querySelectorAll('td, th').forEach(el => {
                if (el.style.verticalAlign !== 'top') {
                  el.style.verticalAlign = 'middle';
                }
                el.style.lineHeight = '1.2';
              });
       
              doc.querySelectorAll('td > div, th > div').forEach(el => {
                el.style.display       = 'flex';
                el.style.alignItems    = 'center';
                el.style.justifyContent = el.dataset.justify || 'center';
                el.style.height        = '26px';
                el.style.width         = '100%';
                el.style.overflow      = 'hidden';
                el.style.whiteSpace    = 'nowrap';
                el.style.fontFamily    = '\'Times New Roman\', Times, serif';
                el.style.fontSize      = '11px';
              });
            },
          },
          jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'},
        })
        .from(printRef.current)
        .save();
      toast.success('Invoice PDF downloaded!');
      onClose();
    } catch {
      toast.error('PDF generation failed');
    } finally {
      setDownloading(false);
    }
  };

  if (!invoiceData) {return null;}

  return (
    <Modal
      open={open}
      onCancel={onClose}
      destroyOnHidden
      width={1100}
      title={(
        <div className={'flex items-center gap-2'}>
          <DownloadOutlined className={'text-blue-600'} />
          <span className={'font-bold text-black-800'}>
            Invoice Preview —{' '}
            <span className={'font-mono text-blue-600'}>{invoiceData.invoiceNo}</span>
          </span>
        </div>
      )}
      styles={{body: {maxHeight: '80vh', overflowY: 'auto', padding: '16px 20px'}}}
      footer={(
        <div className={'flex justify-end gap-3 py-1.5'}>
          <Button className={'btn-secondary'} onClick={onClose}>Close</Button>
          <Button
            icon={<PrinterOutlined />}
            onClick={() => handlePrint && handlePrint()}
          >
            Print Invoice
          </Button>
          <Button
            className={'btn-primary'}
            icon={<DownloadOutlined />}
            loading={downloading}
            onClick={handleDownload}
          >
            Download PDF
          </Button>
        </div>
      )}
    >
      <div className={'border border-slate-200 rounded-lg overflow-hidden shadow-sm'}>
        <InvoiceTemplate invoiceData={invoiceData} printRef={printRef} />
      </div>
    </Modal>
  );
};

GenerateBillPdf.propTypes = {
  open:        PropTypes.bool.isRequired,
  onClose:     PropTypes.func.isRequired,
  invoiceData: PropTypes.object,
};

export default GenerateBillPdf;
